import { z } from 'zod';

/**
 * Per-lot capability flags (the `CanYou` shape from `docs/04-api-contract.md`),
 * returned for each lot in `GET /sales/:saleId`. Derived at read time from the
 * lot/sale state, the user's roles, and their deposits — never persisted. The
 * predicate logic lives in `apps/api/src/lib/eligibility.ts` (see
 * `docs/06-state-machine.md`).
 */
export const canYouSchema = z.object({
  bid: z.boolean(),
  earlyBid: z.boolean(),
  freeBid: z.boolean(),
  deposit: z.boolean(),
  depositLink: z.string().optional(),
  hasDeposit: z.boolean(),
});
export type CanYou = z.infer<typeof canYouSchema>;
